import { Colors } from '../../../../../themes/colors';
import { MultiCheckboxGroup } from '../../../../commonComponents/MultiCheckboxGroup';
import { expectedDaysOptions, scheduleTypeOptions } from '../../shared/constants';
import { FormCard } from '../../shared/FormCard';
import { FormField } from '../../shared/FormField';
import { getErrorStyle } from '../../shared/utils';

export const ScheduleInformationCard = ({ formValues, handleChange, errorStatus }) => (
  <FormCard title="Schedule" style={{ marginTop: 16 }} contentStyle={{ width: '80%' }}>
    <FormField label="Schedule Type" required>
      <select
        className="custom-select custom-select-lg"
        style={{ height: 32, ...getErrorStyle(errorStatus?.invalidScheduleType) }}
        value={formValues.scheduleType}
        onChange={(val) => handleChange('scheduleType', val.target.value)}
      >
        <option value="">Select Schedule Type</option>
        {scheduleTypeOptions.map((option) => (
          <option key={option.code} value={option.code}>
            {option.name}
          </option>
        ))}
      </select>
    </FormField>

    <div style={{ height: 1, backgroundColor: Colors.neutral_200 }} />

    <FormField label="Expected Days">
      <MultiCheckboxGroup
        options={expectedDaysOptions.map((option) => ({
          label: option.name,
          value: option.code,
        }))}
        selectedValues={formValues.expectedDays}
        onChange={(updated) => handleChange('expectedDays', updated)}
      />
    </FormField>
  </FormCard>
);
